import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingStatusForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

import css from './EditListingStatusPanel.module.css';
import { postAdminListingPublic } from '../../util/api';
import { findOptionsForSelectFilter } from '../../util/search';
import BackToAdmin from '../BackToAdminButton/BackToAdminButton';

const { Money } = sdkTypes;

const EditListingStatusPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { price } = currentListing.attributes;
  const { status, boost } = currentListing.attributes.publicData;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingStatusPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingStatusPanel.createListingTitle" />
  );
  const categoryOptions = findOptionsForSelectFilter('status', config.custom.filters);
  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = priceCurrencyValid ? (
    <EditListingStatusForm
      className={css.form}
      initialValues={{ status, boost: boost === 1 ? [true] : null }}
      onSubmit={values => {
        const { status, boost } = values;
        const publicData = {status, boost: !!boost?.includes(true) ? 1 : 0};
        const payload = {
          id: listing.id.uuid,
          publicData
        };
        postAdminListingPublic(payload)
        onSubmit({price});
      }}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
      categories={categoryOptions}
    />
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingStatusPanel.listingPriceCurrencyInvalid" />
    </div>
  );


  return (
    <div className={classes}>
      <BackToAdmin />
      <h1 className={css.title}>{panelTitle}</h1>
      {form}
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingStatusPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingStatusPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingStatusPanel;
